import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConsultationInfoService {

  constructor() {}

  searchType = new BehaviorSubject(null);
  customerIdentificationNumber = new BehaviorSubject(null);
  idTransaction = new BehaviorSubject(null);
  date = new BehaviorSubject(null);
  crm = new BehaviorSubject(null);
  documentType = new BehaviorSubject(null);

  newFormData(form:any) {
    this.searchType.next(form.value.searchType);
    this.customerIdentificationNumber.next(form.value.customerIdentificationNumber);
    this.idTransaction.next(form.value.idTransaction);
    this.date.next(form.value.date);
    this.crm.next(form.value.crm);
    this.documentType.next(form.value.documentType);
  }

  newSearch(form) {
    this.searchType.next("cc");
    this.customerIdentificationNumber.next(form.customerIdentificationNumber);
    this.dateFormat.next(form.date);
    this.crm.next(null);
    this.documentType.next(null);
  }

  getSearchType() {
    return this.searchType.value;
  }

  getCustomerIdentificationNumber() {
    return this.customerIdentificationNumber.value;
  }

  getIdTransaction() {
    return this.idTransaction.value;
  }

  getCRM() {
    return this.crm.value;
  }

  getDocumentType() {
    return this.documentType.value;
  }

  getDate() {
    return this.date.value;
  }

  dateFormat = new BehaviorSubject("");

  dateFormat$ = this.dateFormat.asObservable();

  newDateFormat(format) {
    this.dateFormat.next(format)
  }

  getDateFormat() {
    return this.dateFormat.value;
  }

  results = new BehaviorSubject([]);

  results$ = this.results.asObservable();

  newResults(results) {
    this.results.next(results);
  }

  getResults() {
    return this.results.value;
  }

  detailTransaction = new BehaviorSubject(null);

  detailTransaction$ = this.detailTransaction.asObservable();

  newDetailTransaction(num) {
    this.detailTransaction.next(num);
  }

  getDetailTransaction() {
    return this.detailTransaction.value;
  }

  yearAndMonth = new BehaviorSubject([]);

  yearAndMonth$ = this.yearAndMonth.asObservable();

  newYearAndMonth(year, month) {
    if (year == null || month == null) {
      this.yearAndMonth.next([])
    } else {
      this.yearAndMonth.next([year, month])
    }
  }

  getYearAndMonth() {
    return this.yearAndMonth.value;
  }

  weekSelected = new BehaviorSubject([]);

  weekSelected$ = this.weekSelected.asObservable();

  newWeekSelected(start, end) {
    if (start == null || end == null) {
      this.weekSelected.next([]);
    } else {
      this.weekSelected.next([start, end]);
    }
  }

  getWeekSelected() {
    return this.weekSelected.value;
  }

  lastWeek = new BehaviorSubject([]);

  lastWeek$ = this.lastWeek.asObservable();

  newLastWeek(start, end) {
    if (start == null || end == null) {
      this.lastWeek.next([]);
    } else {
      this.lastWeek.next([start, end]);
    }
  }

  getLastWeek() {
    return this.lastWeek.value;
  }

  transactionDetail = new BehaviorSubject("");

  transactionDetail$ = this.lastWeek.asObservable();

  newTransactiondetail(transactionDetail) {
    this.weekSelected.next(transactionDetail);

  }

  getTransactionDetail() {
    return this.transactionDetail.value;
  }

  fileURL = new BehaviorSubject(null);

  newFileURL(fileURL) {
    this.fileURL.next(fileURL);
  }

  getFileURL() {
    return this.fileURL.value;
  }

}
